import {
  AudienceFilter,
  AudienceFilterType,
  RedirectFilter,
  TrafficConfigFilterType,
} from "@intelligems/ig-types";

type GenericRedirect = {
  originUrl: string;
  destinationUrl?: string | null | undefined;
  isTemplateTest: boolean;
  isThemeTest: boolean;
  filter: RedirectFilter;
};
type GenericPageTargeting = {
  filterType: AudienceFilterType | TrafficConfigFilterType;
  filter?: AudienceFilter | null | undefined;
  value: string;
};
export const getPreviewPathShared = (
  redirects: GenericRedirect[],
  pageTargeting: GenericPageTargeting[],
  useOriginRedirectUrl?: boolean
) => {
  let previewPath: string = "";
  if (!pageTargeting.length) {
    const targetedPath = pageTargeting.find(
      (value) => value.filterType === "url" && value.filter === "equals"
    );
    if (targetedPath) {
      previewPath = `/${targetedPath.value}`;
    }
  }

  if (redirects.length && !previewPath) {
    const firstRedirectFound = redirects.find(
      (redirect) =>
        redirect.originUrl &&
        redirect.destinationUrl &&
        !redirect.isThemeTest &&
        !redirect.isTemplateTest
    );
    if (firstRedirectFound) {
      previewPath = `${
        firstRedirectFound.filter === "matchesExactly" ||
        firstRedirectFound.filter === "none"
          ? ""
          : "/"
      }${firstRedirectFound[useOriginRedirectUrl ? "originUrl" : "destinationUrl"]}`;
    }
  }

  return previewPath;
};
